import { CountResponse, WalletWithAccountId, createUnblockWalletMutation } from 'shared/api';
import { createConfirmModalModel, ConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockWalletModel = ConfirmModalModel<WalletWithAccountId, number, CountResponse>;

export const createUnblockWalletModel = (): UnblockWalletModel => {
	const unblockWalletMutation = createUnblockWalletMutation();

	const model = createConfirmModalModel<WalletWithAccountId, number, CountResponse>({
		modalData: declareModalData<WalletWithAccountId>(),
		mapModalData: ({ id }) => id,
		mutation: unblockWalletMutation,
		successMessageKey: 'unblock-wallet.success',
	});

	return model;
};
